import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_443_9813)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M6.00112 11.5714C9.07817 11.5714 11.5725 9.07706 11.5725 6C11.5725 2.92299 9.07817 0.428572 6.00112 0.428572C2.9241 0.428572 0.429688 2.92299 0.429688 6C0.429688 9.07706 2.9241 11.5714 6.00112 11.5714Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: .8
		}), /* @__PURE__ */ _jsx("path", {
			d: "M8.50223 4.07143L5.07366 8.35714L3.35938 7.07143",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_443_9813",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "currentColor"
		})
	}) })]
});
export default SvgCheckCircle;
